import { render, staticRenderFns } from "./agent-details.vue?vue&type=template&id=7d2946c1&"
import script from "./agent-details.vue?vue&type=script&lang=js&"
export * from "./agent-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports